module.exports = {
  title: `Petteri Pucilowski´s personal blog`,
  description: `In my blog I will document my daily learnings on doing business online and the technical side of it.`,
  author: `[Petteri Pucilowski]`,
  introduction: `My learnings on doing business online. My current main focus is developing the customer journey - from UX to the customer service.`,
  siteUrl: `https://gatsby-starter-bee.netlify.com`, // Your blog site url
  social: {
    twitter: `pucilpet`, // Your Twitter account
    github: `pucilpet`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: `petteri.pucilowski`, // Your Facebook account
    linkedin: `petteri-pucilowski-a0921a99`, // Your LinkedIn account
    instagram: `hersecretfi`, // Your Instagram account
  },
  icon: `content/assets/profile.png`, // Add your favicon
  keywords: [`blog, business, ecommerce, prestashop, ux, react`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'pucilpet/gatsby-blog-petteri', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'pucilpet',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-201057324-1', // Add your google analytics tranking ID
}
